import { useIsTabletOrMobileScreenSize } from '@app/utils/media-query';
import React from 'react';
import LoginButton from './LoginButton';
import Signature from './Signature';
import { Container, DesktopSeparator } from './styles';

export type FooterProps = {
  onLoginClick: () => void;
  hiddenLoginButton: boolean;
};

export default function Footer({ onLoginClick, hiddenLoginButton }: FooterProps) {
  const isTabletOrMobile = useIsTabletOrMobileScreenSize();
  const flexDirection = isTabletOrMobile ? 'column' : 'row';

  return (
    <Container style={{ flexDirection }}>
      {!hiddenLoginButton && (
        <>
          <LoginButton onClick={onLoginClick} />
          <DesktopSeparator style={{ width: isTabletOrMobile ? 0 : 3 }} />
        </>
      )}
      <Signature />
    </Container>
  );
}
